"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatientenTracking = void 0;
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const PatientenTracking_style_1 = require("./PatientenTracking.style");
const GlobalStyles_1 = require("../../../helper/GlobalStyles");
const atome_1 = require("../../atome");
const organisms_1 = require("../../organisms");
const User_service_1 = __importDefault(require("../../../services/User.service"));
const hooks_1 = require("../../../store/hooks");
const reducers_1 = require("../../../store/reducers");
const Breakpoints_1 = require("../../../helper/Breakpoints");
const UtilityFunctions_1 = require("../../../helper/UtilityFunctions");
const InputLoader_1 = __importDefault(require("../../atome/InputLoader/InputLoader"));
// @ts-ignore
function PatientenTracking({ navigation, route }) {
    const [isSaving, setSaving] = (0, react_1.useState)(false);
    const [mood, setMood] = (0, react_1.useState)(0);
    const [joyOfLife, setJoyOfLife] = (0, react_1.useState)(0);
    const [generalActivity, setGeneralActivity] = (0, react_1.useState)(0);
    const [appetite, setAppetite] = (0, react_1.useState)(0);
    const [sexuality, setSexuality] = (0, react_1.useState)(0);
    const [everydayWork, setEverydayWork] = (0, react_1.useState)(0);
    const [concentration, setConcentration] = (0, react_1.useState)(0);
    const [sleep, setSleep] = (0, react_1.useState)(0);
    const [isLoading, setIsLoading] = (0, react_1.useState)(true);
    const [hasAccess, setHasAccess] = (0, react_1.useState)(true);
    const [isError, setIsError] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)('');
    const [data, setData] = (0, react_1.useState)();
    const auth = (0, hooks_1.useAppSelector)(reducers_1.selectAuth);
    const userInformation = (0, hooks_1.useAppSelector)(reducers_1.selectUserInformation);
    const dispatch = (0, hooks_1.useAppDispatch)();
    const navigateTo = (routeName) => {
        navigation.navigate(routeName);
    };
    const getDataForTracking = () => {
        User_service_1.default.getDataForTracking(route.params.token).then(res => {
            if (res.error) {
                setIsError(true);
                setError('error');
            }
            if (!res.error) {
                setData(res.data);
                setIsLoading(false);
            }
        });
    };
    const resetData = () => {
        setMood(0);
        setJoyOfLife(0);
        setGeneralActivity(0);
        setAppetite(0);
        setSexuality(0);
        setEverydayWork(0);
        setConcentration(0);
        setSleep(0);
    };
    (0, react_1.useEffect)(() => {
        if (route.params?.token) {
            //for access via token
            User_service_1.default.checkTrackingToken(route.params.token).then(res => {
                if (res.error) {
                    setHasAccess(false);
                    setIsLoading(false);
                }
                if (!res.error) {
                    getDataForTracking();
                }
            });
            return;
        }
        else if (auth.isAuthenticated) {
            //for acces via login
            setData({ lifeQuality: userInformation.lifeQuality });
            setIsLoading(false);
            setHasAccess(true);
            return;
        }
        setHasAccess(false);
        setIsLoading(false);
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    (0, react_1.useEffect)(() => {
        if (auth.isAuthenticated) {
            //for acces via login
            setData({ lifeQuality: userInformation.lifeQuality });
            setIsLoading(false);
            setHasAccess(true);
        }
    }, [auth.isAuthenticated, userInformation.lifeQuality]);
    const save = async () => {
        setSaving(true);
        setError('');
        //for the backend, 0 has to be converted to 11
        const lifeQualityData = {
            mood: mood === 0 ? 11 : mood,
            joyOfLife: joyOfLife === 0 ? 11 : joyOfLife,
            generalActivity: generalActivity === 0 ? 11 : generalActivity,
            appetite: appetite === 0 ? 11 : appetite,
            sexuality: sexuality === 0 ? 11 : sexuality,
            everydayWork: everydayWork === 0 ? 11 : everydayWork,
            concentration: concentration === 0 ? 11 : concentration,
            sleep: sleep === 0 ? 11 : sleep,
        };
        if (route.params?.token) {
            //for access via token
            let data = {
                lifeQuality: lifeQualityData,
                token: route.params?.token,
            };
            User_service_1.default.saveTrackingData(data).then(res => {
                setSaving(false);
                if (res.error) {
                    setIsError(true);
                    if (res.message.response.status === 401) {
                        setError('access');
                    }
                    else {
                        setError('error');
                    }
                }
                if (!res.error) {
                    resetData();
                    if (route.params && route.params.redirectPage) {
                        navigation.navigate('TrackingSuccess', {
                            redirectPage: route.params.redirectPage,
                        });
                        return;
                    }
                    navigation.navigate('TrackingSuccess');
                }
            });
        }
        else if (auth.isAuthenticated) {
            //for acces via login
            let data = {
                lifeQuality: [lifeQualityData],
            };
            const response = await User_service_1.default.update(data);
            if (response.error) {
                console.log(response.message);
            }
            if (!response.error) {
                data.lifeQuality[0].queryDate = (0, UtilityFunctions_1.todayStripped)();
                data.lifeQuality[0].patientId = parseInt(userInformation.id);
                const newUserInformation = {
                    ...userInformation,
                    lifeQuality: [...userInformation?.lifeQuality, ...data.lifeQuality],
                };
                dispatch((0, reducers_1.setUserInformation)(newUserInformation));
                setData({ lifeQuality: newUserInformation.lifeQuality });
                resetData();
                setSaving(false);
                if (route.params && route.params.redirectPage) {
                    navigation.navigate('TrackingSuccess', {
                        redirectPage: route.params.redirectPage,
                    });
                    return;
                }
                navigation.navigate('TrackingSuccess');
            }
        }
    };
    if (isLoading) {
        return react_1.default.createElement(atome_1.Loading, null);
    }
    if (!hasAccess) {
        return (react_1.default.createElement(react_native_1.SafeAreaView, { style: { backgroundColor: 'white' } },
            react_1.default.createElement(react_native_1.ScrollView, { style: PatientenTracking_style_1.styles.scrollView },
                react_1.default.createElement(organisms_1.BaseHeader, { navigation: navigation }),
                react_1.default.createElement(react_native_1.View, { style: PatientenTracking_style_1.styles.container },
                    react_1.default.createElement(react_native_1.View, { style: [PatientenTracking_style_1.styles.row, PatientenTracking_style_1.styles.justifyCenter, PatientenTracking_style_1.styles.marginBottom15] },
                        react_1.default.createElement(atome_1.Text, { style: [
                                PatientenTracking_style_1.styles.textAlignCenter,
                                PatientenTracking_style_1.styles.fontSize120,
                                PatientenTracking_style_1.styles.fontWeight100,
                            ] }, "403")),
                    react_1.default.createElement(react_native_1.View, { style: [PatientenTracking_style_1.styles.row, PatientenTracking_style_1.styles.justifyCenter, PatientenTracking_style_1.styles.marginBottom25] },
                        react_1.default.createElement(atome_1.Text, { style: [
                                PatientenTracking_style_1.styles.textAlignCenter,
                                PatientenTracking_style_1.styles.fontBold,
                                PatientenTracking_style_1.styles.fontSize24,
                            ] }, "Auf diese Seite darf nicht zugeriffen werden!")),
                    react_1.default.createElement(react_native_1.View, { style: [
                            PatientenTracking_style_1.styles.row,
                            PatientenTracking_style_1.styles.buttonContainer,
                            PatientenTracking_style_1.styles.marginBottom0,
                        ] },
                        react_1.default.createElement(react_native_1.Pressable, { style: PatientenTracking_style_1.styles.button, onPress: () => navigateTo('Login') },
                            react_1.default.createElement(atome_1.Text, { style: [PatientenTracking_style_1.styles.buttonText] }, "ZUM LOGIN"))),
                    react_1.default.createElement(react_native_1.View, { style: [PatientenTracking_style_1.styles.row, PatientenTracking_style_1.styles.buttonContainer] },
                        react_1.default.createElement(react_native_1.Pressable, { onPress: () => navigateTo('RegisterProcedure') },
                            react_1.default.createElement(atome_1.Text, { style: [PatientenTracking_style_1.styles.backButtonText] }, "Jetzt registrieren")))))));
    }
    return (react_1.default.createElement(react_native_1.SafeAreaView, { style: PatientenTracking_style_1.styles.whiteBackground },
        react_1.default.createElement(react_native_1.ScrollView, { style: PatientenTracking_style_1.styles.scrollView },
            route.params?.token && react_1.default.createElement(organisms_1.BaseHeader, null),
            auth.isAuthenticated && react_1.default.createElement(organisms_1.UserHeader, { navigation: navigation }),
            react_1.default.createElement(react_native_1.View, { style: PatientenTracking_style_1.styles.container },
                react_1.default.createElement(react_native_1.View, { style: [PatientenTracking_style_1.styles.row] },
                    react_1.default.createElement(atome_1.Modal, { modalVisible: isError && error === 'error', setModalVisible: setIsError, disableSecondaryButton: true, cb: () => {
                            setIsError(false);
                        } },
                        react_1.default.createElement(atome_1.Text, { style: [PatientenTracking_style_1.styles.textAlignCenter] }, "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut. Wenn das Problem weiterhin besteht, wenden Sie sich bitte an den Support.")),
                    react_1.default.createElement(atome_1.Modal, { modalVisible: isError && error === 'access', setModalVisible: setIsError, disableSecondaryButton: true, cb: () => {
                            setIsError(false);
                            setHasAccess(false);
                        } },
                        react_1.default.createElement(atome_1.Text, { style: [PatientenTracking_style_1.styles.textAlignCenter] }, "Der Link ist in der Zeit abgelaufen.")),
                    (Breakpoints_1.isPhablet || Breakpoints_1.isDesktop) && (react_1.default.createElement(atome_1.Icon, { icon: 'healthTracking', size: 150 })),
                    react_1.default.createElement(react_native_1.View, { style: [
                            Breakpoints_1.isPhablet || Breakpoints_1.isDesktop ? PatientenTracking_style_1.styles.marginLeft40 : null,
                            !Breakpoints_1.isPhablet && !Breakpoints_1.isDesktop
                                ? { width: '100%', marginBottom: 20 }
                                : { marginBottom: 40 },
                            react_native_1.Platform.OS !== 'web' ? { marginTop: 40 } : null,
                        ] },
                        react_native_1.Platform.OS === 'web' && (react_1.default.createElement(atome_1.Text, { style: [PatientenTracking_style_1.styles.heading3, PatientenTracking_style_1.styles.marginBottom0] }, "Therapie Monitoring")),
                        react_1.default.createElement(atome_1.Text, { style: [PatientenTracking_style_1.styles.heading2] }, "Wie geht es Ihnen heute?"),
                        react_1.default.createElement(atome_1.Label, null, "Wie sch\u00E4tzen Sie die folgenden Bereiche Ihres t\u00E4glichen Lebens auf einer Skala von 0 (sehr schlecht) bis 10 (sehr gut) ein?"))),
                react_1.default.createElement(react_native_1.View, null,
                    react_1.default.createElement(react_native_1.View, { style: [
                            Breakpoints_1.isPhablet || Breakpoints_1.isDesktop ? PatientenTracking_style_1.styles.row : PatientenTracking_style_1.styles.column,
                            PatientenTracking_style_1.styles.marginRow,
                        ] },
                        react_1.default.createElement(atome_1.Label, { style: [PatientenTracking_style_1.styles.questionLabel, PatientenTracking_style_1.styles.marginTopText] }, "Stimmung"),
                        react_1.default.createElement(atome_1.Slider, { style: [PatientenTracking_style_1.styles.slider], value: mood, minimumValue: 0, maximumValue: 10, showScale: true, step: 1, thumbTintColor: "#3db384", minimumTrackTintColor: "#c2c2c2", maximumTrackTintColor: "#c2c2c2", onValueChange: value => setMood(value) }),
                        react_1.default.createElement(react_native_1.View, { style: [
                                PatientenTracking_style_1.styles.row,
                                PatientenTracking_style_1.styles.marginTopText,
                                PatientenTracking_style_1.styles.marginLeftText,
                                PatientenTracking_style_1.styles.flex025,
                                Breakpoints_1.isPhablet || Breakpoints_1.isDesktop ? null : PatientenTracking_style_1.styles.marginTop25,
                            ] },
                            react_1.default.createElement(atome_1.Text, null, "Zuletzt: "),
                            react_1.default.createElement(atome_1.Text, { style: [PatientenTracking_style_1.styles.fontBold] }, data?.lifeQuality[data?.lifeQuality.length - 1]?.mood === 11
                                ? 0
                                : data?.lifeQuality[data?.lifeQuality.length - 1]?.mood))),
                    react_1.default.createElement(react_native_1.View, { style: [
                            Breakpoints_1.isPhablet || Breakpoints_1.isDesktop ? PatientenTracking_style_1.styles.row : PatientenTracking_style_1.styles.column,
                            PatientenTracking_style_1.styles.marginRow,
                        ] },
                        react_1.default.createElement(atome_1.Label, { style: [PatientenTracking_style_1.styles.questionLabel, PatientenTracking_style_1.styles.marginTopText] }, "Lebensfreude"),
                        react_1.default.createElement(atome_1.Slider, { style: [PatientenTracking_style_1.styles.slider], value: joyOfLife, minimumValue: 0, maximumValue: 10, showScale: true, step: 1, thumbTintColor: "#3db384", minimumTrackTintColor: "#c2c2c2", maximumTrackTintColor: "#c2c2c2", onValueChange: value => setJoyOfLife(value) }),
                        react_1.default.createElement(react_native_1.View, { style: [
                                PatientenTracking_style_1.styles.row,
                                PatientenTracking_style_1.styles.marginTopText,
                                PatientenTracking_style_1.styles.marginLeftText,
                                PatientenTracking_style_1.styles.flex025,
                                Breakpoints_1.isPhablet || Breakpoints_1.isDesktop ? null : PatientenTracking_style_1.styles.marginTop25,
                            ] },
                            react_1.default.createElement(atome_1.Text, null, "Zuletzt: "),
                            react_1.default.createElement(atome_1.Text, { style: [PatientenTracking_style_1.styles.fontBold] }, data?.lifeQuality[data?.lifeQuality.length - 1]
                                ?.joyOfLife === 11
                                ? 0
                                : data?.lifeQuality[data?.lifeQuality.length - 1]
                                    ?.joyOfLife))),
                    react_1.default.createElement(react_native_1.View, { style: [
                            Breakpoints_1.isPhablet || Breakpoints_1.isDesktop ? PatientenTracking_style_1.styles.row : PatientenTracking_style_1.styles.column,
                            PatientenTracking_style_1.styles.marginRow,
                        ] },
                        react_1.default.createElement(atome_1.Label, { style: [PatientenTracking_style_1.styles.questionLabel, PatientenTracking_style_1.styles.marginTopText] }, "Allgemeine Aktivit\u00E4t / k\u00F6rperliche Belastbarkeit"),
                        react_1.default.createElement(atome_1.Slider, { style: [PatientenTracking_style_1.styles.slider], value: generalActivity, minimumValue: 0, maximumValue: 10, showScale: true, step: 1, thumbTintColor: "#3db384", minimumTrackTintColor: "#c2c2c2", maximumTrackTintColor: "#c2c2c2", onValueChange: value => setGeneralActivity(value) }),
                        react_1.default.createElement(react_native_1.View, { style: [
                                PatientenTracking_style_1.styles.row,
                                PatientenTracking_style_1.styles.marginTopText,
                                PatientenTracking_style_1.styles.marginLeftText,
                                PatientenTracking_style_1.styles.flex025,
                                Breakpoints_1.isPhablet || Breakpoints_1.isDesktop ? null : PatientenTracking_style_1.styles.marginTop25,
                            ] },
                            react_1.default.createElement(atome_1.Text, null, "Zuletzt: "),
                            react_1.default.createElement(atome_1.Text, { style: [PatientenTracking_style_1.styles.fontBold] }, data?.lifeQuality[data?.lifeQuality.length - 1]
                                ?.generalActivity === 11
                                ? 0
                                : data?.lifeQuality[data?.lifeQuality?.length - 1]
                                    ?.generalActivity))),
                    react_1.default.createElement(react_native_1.View, { style: [
                            Breakpoints_1.isPhablet || Breakpoints_1.isDesktop ? PatientenTracking_style_1.styles.row : PatientenTracking_style_1.styles.column,
                            PatientenTracking_style_1.styles.marginRow,
                        ] },
                        react_1.default.createElement(atome_1.Label, { style: [PatientenTracking_style_1.styles.questionLabel, PatientenTracking_style_1.styles.marginTopText] }, "Appetit"),
                        react_1.default.createElement(atome_1.Slider, { style: [PatientenTracking_style_1.styles.slider], value: appetite, minimumValue: 0, maximumValue: 10, showScale: true, step: 1, thumbTintColor: "#3db384", minimumTrackTintColor: "#c2c2c2", maximumTrackTintColor: "#c2c2c2", onValueChange: value => setAppetite(value) }),
                        react_1.default.createElement(react_native_1.View, { style: [
                                PatientenTracking_style_1.styles.row,
                                PatientenTracking_style_1.styles.marginTopText,
                                PatientenTracking_style_1.styles.marginLeftText,
                                PatientenTracking_style_1.styles.flex025,
                                Breakpoints_1.isPhablet || Breakpoints_1.isDesktop ? null : PatientenTracking_style_1.styles.marginTop25,
                            ] },
                            react_1.default.createElement(atome_1.Text, null, "Zuletzt: "),
                            react_1.default.createElement(atome_1.Text, { style: [PatientenTracking_style_1.styles.fontBold] }, data?.lifeQuality[data?.lifeQuality.length - 1]?.appetite ===
                                11
                                ? 0
                                : data?.lifeQuality[data?.lifeQuality.length - 1]?.appetite))),
                    react_1.default.createElement(react_native_1.View, { style: [
                            Breakpoints_1.isPhablet || Breakpoints_1.isDesktop ? PatientenTracking_style_1.styles.row : PatientenTracking_style_1.styles.column,
                            PatientenTracking_style_1.styles.marginRow,
                        ] },
                        react_1.default.createElement(atome_1.Label, { style: [PatientenTracking_style_1.styles.questionLabel, PatientenTracking_style_1.styles.marginTopText] }, "Sexualit\u00E4t"),
                        react_1.default.createElement(atome_1.Slider, { style: [PatientenTracking_style_1.styles.slider], value: sexuality, minimumValue: 0, maximumValue: 10, showScale: true, step: 1, thumbTintColor: "#3db384", minimumTrackTintColor: "#c2c2c2", maximumTrackTintColor: "#c2c2c2", onValueChange: value => setSexuality(value) }),
                        react_1.default.createElement(react_native_1.View, { style: [
                                PatientenTracking_style_1.styles.row,
                                PatientenTracking_style_1.styles.marginTopText,
                                PatientenTracking_style_1.styles.marginLeftText,
                                PatientenTracking_style_1.styles.flex025,
                                Breakpoints_1.isPhablet || Breakpoints_1.isDesktop ? null : PatientenTracking_style_1.styles.marginTop25,
                            ] },
                            react_1.default.createElement(atome_1.Text, null, "Zuletzt: "),
                            react_1.default.createElement(atome_1.Text, { style: [PatientenTracking_style_1.styles.fontBold] }, data?.lifeQuality[data?.lifeQuality.length - 1]
                                ?.sexuality === 11
                                ? 0
                                : data?.lifeQuality[data?.lifeQuality.length - 1]
                                    ?.sexuality))),
                    react_1.default.createElement(react_native_1.View, { style: [
                            Breakpoints_1.isPhablet || Breakpoints_1.isDesktop ? PatientenTracking_style_1.styles.row : PatientenTracking_style_1.styles.column,
                            PatientenTracking_style_1.styles.marginRow,
                        ] },
                        react_1.default.createElement(atome_1.Label, { style: [PatientenTracking_style_1.styles.questionLabel, PatientenTracking_style_1.styles.marginTopText] }, "Beruf / Allt\u00E4gliche Arbeit"),
                        react_1.default.createElement(atome_1.Slider, { style: [PatientenTracking_style_1.styles.slider], value: everydayWork, minimumValue: 0, maximumValue: 10, showScale: true, step: 1, thumbTintColor: "#3db384", minimumTrackTintColor: "#c2c2c2", maximumTrackTintColor: "#c2c2c2", onValueChange: value => setEverydayWork(value) }),
                        react_1.default.createElement(react_native_1.View, { style: [
                                PatientenTracking_style_1.styles.row,
                                PatientenTracking_style_1.styles.marginTopText,
                                PatientenTracking_style_1.styles.marginLeftText,
                                PatientenTracking_style_1.styles.flex025,
                                Breakpoints_1.isPhablet || Breakpoints_1.isDesktop ? null : PatientenTracking_style_1.styles.marginTop25,
                            ] },
                            react_1.default.createElement(atome_1.Text, null, "Zuletzt: "),
                            react_1.default.createElement(atome_1.Text, { style: [PatientenTracking_style_1.styles.fontBold] }, data?.lifeQuality[data?.lifeQuality.length - 1]
                                ?.everydayWork === 11
                                ? 0
                                : data?.lifeQuality[data?.lifeQuality.length - 1]
                                    ?.everydayWork))),
                    react_1.default.createElement(react_native_1.View, { style: [
                            Breakpoints_1.isPhablet || Breakpoints_1.isDesktop ? PatientenTracking_style_1.styles.row : PatientenTracking_style_1.styles.column,
                            PatientenTracking_style_1.styles.marginRow,
                        ] },
                        react_1.default.createElement(atome_1.Label, { style: [PatientenTracking_style_1.styles.questionLabel, PatientenTracking_style_1.styles.marginTopText] }, "Geistige T\u00E4tigkeiten / Konzentration"),
                        react_1.default.createElement(atome_1.Slider, { style: [PatientenTracking_style_1.styles.slider], value: concentration, minimumValue: 0, maximumValue: 10, showScale: true, step: 1, thumbTintColor: "#3db384", minimumTrackTintColor: "#c2c2c2", maximumTrackTintColor: "#c2c2c2", onValueChange: value => setConcentration(value) }),
                        react_1.default.createElement(react_native_1.View, { style: [
                                PatientenTracking_style_1.styles.row,
                                PatientenTracking_style_1.styles.marginTopText,
                                PatientenTracking_style_1.styles.marginLeftText,
                                PatientenTracking_style_1.styles.flex025,
                                Breakpoints_1.isPhablet || Breakpoints_1.isDesktop ? null : PatientenTracking_style_1.styles.marginTop25,
                            ] },
                            react_1.default.createElement(atome_1.Text, null, "Zuletzt: "),
                            react_1.default.createElement(atome_1.Text, { style: [PatientenTracking_style_1.styles.fontBold] }, data?.lifeQuality[data?.lifeQuality.length - 1]
                                ?.concentration === 11
                                ? 0
                                : data?.lifeQuality[data?.lifeQuality.length - 1]
                                    ?.concentration))),
                    react_1.default.createElement(react_native_1.View, { style: [
                            Breakpoints_1.isPhablet || Breakpoints_1.isDesktop ? PatientenTracking_style_1.styles.row : PatientenTracking_style_1.styles.column,
                            PatientenTracking_style_1.styles.marginRow,
                        ] },
                        react_1.default.createElement(atome_1.Label, { style: [PatientenTracking_style_1.styles.questionLabel, PatientenTracking_style_1.styles.marginTopText] }, "Schlaf"),
                        react_1.default.createElement(atome_1.Slider, { style: [PatientenTracking_style_1.styles.slider], value: sleep, minimumValue: 0, maximumValue: 10, showScale: true, step: 1, thumbTintColor: "#3db384", minimumTrackTintColor: "#c2c2c2", maximumTrackTintColor: "#c2c2c2", onValueChange: value => setSleep(value) }),
                        react_1.default.createElement(react_native_1.View, { style: [
                                PatientenTracking_style_1.styles.row,
                                PatientenTracking_style_1.styles.marginTopText,
                                PatientenTracking_style_1.styles.marginLeftText,
                                PatientenTracking_style_1.styles.flex025,
                                Breakpoints_1.isPhablet || Breakpoints_1.isDesktop ? null : PatientenTracking_style_1.styles.marginTop25,
                            ] },
                            react_1.default.createElement(atome_1.Text, null, "Zuletzt: "),
                            react_1.default.createElement(atome_1.Text, { style: [PatientenTracking_style_1.styles.fontBold] }, data?.lifeQuality[data?.lifeQuality.length - 1]?.sleep === 11
                                ? 0
                                : data?.lifeQuality[data?.lifeQuality.length - 1]?.sleep))),
                    react_1.default.createElement(react_native_1.View, { style: [PatientenTracking_style_1.styles.row, PatientenTracking_style_1.styles.marginRow, PatientenTracking_style_1.styles.buttonContainer] },
                        react_1.default.createElement(react_native_1.Pressable, { pointerEvents: isSaving ? 'none' : 'auto', style: [
                                isSaving ? PatientenTracking_style_1.styles.buttonLoading : PatientenTracking_style_1.styles.button,
                                GlobalStyles_1.globalStyles.saveButtonContainer,
                            ], onPress: save },
                            isSaving ? react_1.default.createElement(InputLoader_1.default, null) : null,
                            react_1.default.createElement(atome_1.Text, { style: [PatientenTracking_style_1.styles.buttonText] }, "ABSENDEN"))))))));
}
exports.PatientenTracking = PatientenTracking;
